if (!window.pbRewardsEntryBound) {
    window.pbRewardsEntryBound = true;
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest('[data-pb-open-rewards]');
      if (!link) return;
      var trigger = document.querySelector('.perkstack-launcher__trigger--ready');
      if (!trigger) return;
      event.preventDefault();
      if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
    });
  }

// Perkstack's merchant-defined launcher label is global; localize this one control on HU.
(function () {
  if (document.documentElement.lang.split('-')[0] !== 'hu') return;
  function attach() {
    var trigger = document.querySelector('[data-perkstack-trigger]');
    if (!trigger) return false;
    function localize() {
      var label = trigger.querySelector('.perkstack-launcher__trigger-label');
      if (label && label.textContent !== 'Jutalmak') label.textContent = 'Jutalmak';
      if (trigger.getAttribute('aria-label') !== 'Jutalmak') trigger.setAttribute('aria-label', 'Jutalmak');
    }
    localize();
    // The app replaces merchant labels when its async configuration arrives.
    new MutationObserver(localize).observe(trigger, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['aria-label']});
    return true;
  }
  if (attach()) return;
  var pending = new MutationObserver(function () { if (attach()) pending.disconnect(); });
  pending.observe(document.body, {childList:true,subtree:true});
})();
